import { useEffect } from 'react';
import { acquireBodyScrollLock } from './bodyScrollLock';

/** Lock document scroll while `active` is true (refcounted). */
export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    return acquireBodyScrollLock();
  }, [active]);
}
